<template>
  <div class="content-section" id="about-me">
    <br />
    <br />
    <div class="pt-10"></div>
    <div class="content-section__body about-me__body px-4">
      <div class="hover-quotation">&#10077;</div>
      <p>
        I'm a third-year
        <text-link url="https://www.comp.nus.edu.sg/">NUS</text-link>
        student majoring in Computer Science along with the
        <text-link url="https://www.usp.nus.edu.sg/"
          >University Scholars' Programme (USP)</text-link
        >. I'm passionate about software that's meaningful, exciting and
        challenging!
      </p>
      <p>
        I currently work on engineering at the
        <text-link url="https://aphrodite.global/">Aphrodite Project</text-link
        >. I also contribute to
        <text-link url="https://github.com/MarkBind/markbind"
          >MarkBind</text-link
        >, an open-source static site generator for content-heavy websites.
      </p>
      <p>
        Previously at:
        <text-link url="https://stripe.com/">Stripe</text-link> (full-stack),
        <text-link url="https://www.bytedance.com/en/">ByteDance</text-link>
        (tech infra),
        <text-link url="https://www.comp.nus.edu.sg/~vwo/">CVWO</text-link>
        (backend & DevOps).
      </p>
      <p>
        Outside of computers, I enjoy running, playing football (&#9917;),
        crochet and cubing.
      </p>
      <p>
        Thanks for visiting! &#9787;
      </p>
    </div>
  </div>
</template>

<script>
import TextLink from '@/components/utilities/TextLink';

export default {
  name: 'AboutMe',
  components: {
    TextLink,
  },
};
</script>

<style lang="scss" scoped>
.about-me__body {
  text-align: center;
  font-size: 1.1em;
  max-width: 700px;
  margin: 0 auto;
  padding-left: 50px;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}

.about-me__card {
  background-color: white;
  border-radius: 0.8em;
  box-shadow: 10px 10px 20px 5px rgba(211, 211, 211, 0.651);
}

.hover-quotation {
  font-size: 4em;
  color: #8fbaaf;
  text-shadow: -2px 2px 13px #cccccc;
  width: 100%;
  max-width: 800px;
}
</style>
